import { Button } from "@/components/ui/button";

interface UnitRentButtonProps {
    tier?: string;
    handleRentalClick: () => void;
    label?: string;
    dataState?: "open" | "closed";
    ariaControls?: string;
}

export const RentButton = ({
    tier = "tierA",
    handleRentalClick,
    label = "Rent",
    dataState,
    ariaControls,
}: UnitRentButtonProps) => {
    const bgClass =
        tier === "tierB" ? "tw:bg-(--secondary)" : "tw:bg-(--primary)";
    const expandedClass = dataState === "open" ? " expanded" : "";

    return (
        <Button
            variant="default"
            data-testid="rentButton"
            data-state={dataState}
            onClick={handleRentalClick}
            className={`${bgClass} hover:${bgClass} tw:hover:brightness-75 rent-btn${expandedClass}`}
            aria-label={label}
            aria-expanded={dataState === "open" ? true : undefined}
            aria-controls={ariaControls}
            type="button"
        >
            {label}
        </Button>
    );
};

RentButton.displayName = "RentButton";
